<template>
  <Anchor @click="$emit('openLink')">
    {{title}}
    <Icon
      small
      :color="titleColor"
    >
      mdi-open-in-new
    </Icon>
  </Anchor>
</template>
<script>
import { Anchor, Icon } from '@mikmak/components';

export default {
  props: {
    title: String,
    color: String,
  },
  components: {
    Anchor,
    Icon,
  },
  data() {
    return {
      titleColor: this.color || '#4369F4',
    };
  },
  computed: {
    titleStyle() {
      return `color: ${this.titleColor};`;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .link {
  span {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
}
</style>
